import { actionClient } from '@/api'

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async getGoodsList({ commit }, price) {
      return actionClient.get('offline', { query: {price} })
    },
    async payGoods({ commit }, obj) {
      return actionClient.post('offline', obj)
    }
  }
}